import React from "react";

const DeleteAvis = () => {
  return <div>Delete Avis</div>;
};

export { DeleteAvis };
